<template>
  <div>
      <!-- <subscribe></subscribe> -->

    <div class="login" @mousemove="mousemove">
      <div id="F-dynamicbg-box">
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
        <div style="z-index: 0"></div>
      </div>


      <!-- <div class="language-switch">
        <span class="language theme-text">中文</span>
        <span class="divider"></span>
        <span class="language">English</span>
      </div> -->
      <div class="login-form">
        <img src="../assets/img/logo.a13e.svg" alt="Dmartech" class="logo">
        <div class="login-table">
          <el-input size="mini" round clearable :placeholder="$t('message.邮箱')" v-model="email" class="login-field"/>
          <el-input size="mini" round show-password :placeholder="$t('message.密码')" minlength="6" v-model="pass" class="login-field"/>
          <el-input size="mini" round clearable :placeholder="$t('message.验证码')" v-model="vcode" class="login-field"/>
          <div class="place" v-if="handleID != ''">
            <img :src="'/vimg?handleid=' + handleID" class="place-img" @click="reflushVCode">
            <el-button size="small" type="success" @click="doLogin">{{$t('message.登录')}}</el-button>
          </div>
        </div>
      </div> 
      <!-- <div class="site-info">
        <a href="http://beian.miit.gov.cn/" target="_blank" class="theme-text">沪ICP备14039474号-14</a>
        copyright©1999-2021 Dmartech All rights reserved.
        <img src="/static/images/guard.d028.png">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602002926" target="_blank" class="theme-text">沪公网安备 31010602002926号</a>
      </div> -->
      <el-dialog :title="$t('message.账号激活')" width="450px" :visible.sync="showActivation" :before-close="handleClose">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="100px">
          <el-form-item :label="$t('message.输入您的姓名')" :label-width="formLabelWidth" prop="name">
            <el-input size="small" round clearable placeholder="Name" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.请输入密码')" :label-width="formLabelWidth" prop="password">
            <el-input size="small" round show-password placeholder="Input Password" minlength="6" v-model="form.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.再次确认密码')" :label-width="formLabelWidth" prop="passwordAgain">
            <el-input size="small" round show-password placeholder="Confirm Password" minlength="6" v-model="form.passwordAgain" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.请选择性别')" :label-width="formLabelWidth"  prop="gender">
            <el-select size="small" v-model="form.gender" default-first-option :placeholder="$t('message.请选择性别')">
              <el-option :label="$t('message.保密')" value="0"></el-option>
              <el-option :label="$t('message.男')" value="1"></el-option>
              <el-option :label="$t('message.女')" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showActivation = false">{{$t('message.取消')}}</el-button>
          <el-button type="success" @click="doActivation('ruleForm')">{{$t('message.确认')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
// import subscribe from '@/components/subscribe/subscribe.vue'
export default {
  name: "login",
  components:{
    // subscribe
  },
  data() {
    return {
      checked: "",
      email: "",
      pass: "",
      vcode: "",
      handleID: "",
      showActivation: false,
      form: {
        userID: "",
        name: "",
        password: "",
        passwordAgain: "",
        activationKey: "",
        gender: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [
          { required: true, message: this.$t('message.输入您的姓名'), trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: this.$t('message.验证长度',['2-50']),
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: this.$t('message.请输入密码'), trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: this.$t('message.验证长度',['6-50']),
            trigger: "blur",
          },
        ],
        passwordAgain: [
          { required: true, message: this.$t('message.再次确认密码'), trigger: "blur" },
          {
            validator: this.onComfirmPass,
            message: this.$t('message两次输入密码不一致'),
            trigger: "blur",
          },
        ],
        gender: [{ required: true, message: this.$t('message.请选择性别'), trigger: "change" }],
      },
    };
  },
  methods: {
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
    mousemove() {},
    doLogin() {
      // 登录
      // rejecthttp(false,'post',"/manage/product/getproductlist",this.sendData,this,(doc) => {
      //       changeflagCLOSED(doc,0,this)
      //       if(doc.data.Code == "MSGKEY_OK"){
      //         this.pageConfig.total = doc.data.exData.datas;
      //       console.log(doc.data);
      //       this.tableData = doc.data.data;
      //       this.toggleSelection();
      //       }
      //       })
      this.$http
        .post("/manage/login", {
          name: this.email,
          pass: this.pass,
          handleid: this.handleID,
          vcode: this.vcode,
        })
        .then((doc) => {
          console.log(doc.data);
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: commonUtil.getMSGType(doc.data.Type),
              message: doc.data.Message,
            });

            console.log(doc.data.Code);

            if (doc.data.Code == "MSGKEY_M2020") {
              console.log("this.showActivation");
              this.form.userID = doc.data.data.userID;
              this.form.name = doc.data.data.name;
              this.form.activationKey = doc.data.data.activationKey;
              this.showActivation = true;
            } else if (doc.data.Code != "MSGKEY_M1000") this.reflushVCode();
          } else {
            this.$store.commit("myUid", doc.data.data.userID);
            this.$store.commit("myUname", doc.data.data.name);
            this.$router.push({ name: "homeEdit" });
          }
        });
    },
    greeting() {
      // this.$http
      //   .get("/manage/greeting", { params: { type: "mmlogin" } })
      //   .then((doc) => {
      //     console.log(doc);
      //   });
    },
    reflushVCode() {
      this.$http
        .get("/manage/getvcode", { params: { type: "mmlogin" } })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.handleID = doc.data.data;
          }
        });
    },
    //生成随机数
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    onComfirmPass(rule, value, callback) {
      if (this.form.password != this.form.passwordAgain) {
        //显示错误提示
        if (callback) callback(false);
        return false;
      }
      return true;
    },
    doActivation(formName) {
      let valiOK = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
        }
        else valiOK = false;
      });
      if(!valiOK) return;
      //检查密码正确性
      if (!this.onComfirmPass()) {
        return;
      }
      this.$http
        .post("/manage/activation", {
          userID: this.form.userID,
          password: this.form.password,
          name: this.form.name,
          activationKey: this.form.activationKey,
          gender: this.form.gender,
        })
        .then((doc) => {
          console.log(doc.data);
          this.showActivation = false;
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: commonUtil.getMSGType(doc.data.Type),
              message: doc.data.Message,
            });
            console.log(doc.data.Code);
            this.reflushVCode();
          } else {
            this.$store.commit("myUid", doc.data.data.userID);
            this.$store.commit("myUname", doc.data.data.name);
            this.$router.push({ name: "home" });
          }
        });
    },
  },
  created() {
    this.greeting();
  },
  mounted() {
    //生成背景的方块 用$nextTick防止F-dynamicbg-box里面内容没有挂载完
    this.$nextTick(function () {
      var box = document.getElementById("F-dynamicbg-box");
      if (box) {
        var div = box.getElementsByTagName("div");
        var math = [0, 3];
        var width =
          document.documentElement.clientWidth || document.body.clientWidth;
        var height =
          document.documentElement.clientHeight || document.body.clientHeight;
        for (var i = 0; i < div.length; i++) {
          math[1] = this.randomNum(10, 30);
          if (math[1] != math[2]) {
            div[i].style.width = math[1] + "px";
            div[i].style.height = math[1] + "px";
            math[2] = math[1];
          }
        }
        for (var i = 0; i < div.length; i++) {
          div[i].style.left = this.randomNum(15, 85) + "vw";
          div[i].style.transform = "rotate(" + this.randomNum(5, 360) + "deg)";
        }
      }
    });
    this.reflushVCode();
  },
};
</script>

<style scoped>
.login {
  background: url(/static/images/login-bg.6d97.svg) no-repeat 50%;
  background-size: cover;
  height: 100vh;
  width: 100vw;
}
.language-switch {
  color: #8c8c8c;
  float: right;
  line-height: 24px;
  margin-right: 16px;
  margin-top: 16px;
}

.language-switch .language {
  cursor: pointer;
  margin: 0 8px;
}

.theme-text {
  color: #0cc2a9;
}

.language-switch .divider {
  border-left: 1px solid #e0e5ea;
  display: inline-block;
  height: 12px;
  margin-top: 6px;
  vertical-align: top;
  width: 0;
}

.login-form {
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  align-items: center;
  display: flex;
  flex-direction: row;
  left: 50%;
  margin: auto;
  max-width: 688px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.login-form .login-table {
  border-left: 1px solid #8daac5;
  margin-left: 2em;
  padding: 2em;
  white-space: nowrap;
}

.login-form .place {
  display: flex;
}

.place-img {
  width: 160px;
  height: 40px;
  margin-right: 12px;
}

.login-field {
  background-color: #434b51;
  border: 1px solid #e0e5ea;
  border-radius: 4px;
  color: #0cc2a9;
  display: block;
  letter-spacing: 1px;
  margin-bottom: 1em;
  width: 240px;
}

.site-info {
  bottom: 0;
  color: #8c8c8c;
  left: 0;
  padding: 1em;
  position: absolute;
  right: 0;
  text-align: center;
}

#F-dynamicbg-box {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
#F-dynamicbg-box > div {
  z-index: -9999;
  background-color: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 105vh;
  /*infinite   表示循环 */
  animation: dynamicDiv 20s linear infinite;
}
#F-dynamicbg-box > div:nth-of-type(1) {
  animation-delay: 1s;
}
#F-dynamicbg-box > div:nth-of-type(2) {
  animation-delay: 2s;
}
#F-dynamicbg-box > div:nth-of-type(3) {
  animation-delay: 3s;
}
#F-dynamicbg-box > div:nth-of-type(4) {
  animation-delay: 4s;
}
#F-dynamicbg-box > div:nth-of-type(5) {
  animation-delay: 5s;
}
#F-dynamicbg-box > div:nth-of-type(6) {
  animation-delay: 6;
}
#F-dynamicbg-box > div:nth-of-type(7) {
  animation-delay: 7s;
}
#F-dynamicbg-box > div:nth-of-type(8) {
  animation-delay: 8s;
}
#F-dynamicbg-box > div:nth-of-type(9) {
  animation-delay: 9s;
}
#F-dynamicbg-box > div:nth-of-type(10) {
  animation-delay: 10s;
}
#F-dynamicbg-box > div:nth-of-type(11) {
  animation-delay: 11s;
}
#F-dynamicbg-box > div:nth-of-type(12) {
  animation-delay: 12s;
}
#F-dynamicbg-box > div:nth-of-type(13) {
  animation-delay: 13s;
}
#F-dynamicbg-box > div:nth-of-type(14) {
  animation-delay: 14s;
}
#F-dynamicbg-box > div:nth-of-type(15) {
  animation-delay: 15s;
}
#F-dynamicbg-box > div:nth-of-type(16) {
  animation-delay: 16;
}
#F-dynamicbg-box > div:nth-of-type(17) {
  animation-delay: 17s;
}
#F-dynamicbg-box > div:nth-of-type(18) {
  animation-delay: 18s;
}
#F-dynamicbg-box > div:nth-of-type(19) {
  animation-delay: 19s;
}
#F-dynamicbg-box > div:nth-of-type(20) {
  animation-delay: 20s;
}

@keyframes dynamicDiv {
  form {
    top: 105vh;
    transform: scale(1.2);
  }
  to {
    top: -13vh;
    transform: scale(1) rotate(120deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue